import { FieldError, Input, Label, TextField, type TextFieldProps } from "react-aria-components";

export function Field({ label, error, ...props }: TextFieldProps & { label: string; error?: string | undefined }) {
  return (
    <TextField className="field" isInvalid={Boolean(error)} {...props}>
      <Label>{label}</Label>
      <Input />
      <FieldError>{error}</FieldError>
    </TextField>
  );
}

/** Read an emailed token from ?token= once, then remove it from the address bar and history. */
export function takeTokenFromUrl(): string | null {
  const url = new URL(window.location.href);
  const token = url.searchParams.get("token");
  if (token) {
    url.searchParams.delete("token");
    window.history.replaceState(window.history.state, "", url.pathname + url.search + url.hash);
  }
  return token;
}
